import * as React from 'react';

import {Box, Card, CardActions, CardContent, Typography} from "@mui/material";
import {PieChart} from "react-minimal-pie-chart";
import {formatNumber, formatPercentage, getTrendIcon} from "../../../Utils";
import AccordeonPersonna from "./AccordeonPersonna";

export default function PersonnasHighestAndDynamic({title, data, displayAlert, n, t1, t2, second, info, items,unit}) {


    function generateAlert(dynamic, nom, nombre) {
        let d = Math.abs(dynamic);
        let message = "";
        let color = "#000";
        if (d > 0.15) {
            message = "Dynamique exceptionnelle"
            color = "red"
        } else if (d > 0.056) {
            message = "Dynamique très marquée"
            color = "orange"
        } else if (d > 0.031) {
            message = "Dynamique marquée"
        } else if (d > 0.01) {
            message = "Dynamique peu marquée"
        } else if (d > -0.01) {
            message = ""
        } else if (d > -0.031) {
            message = "Dynamique peu marquée"
        } else if (d > -0.056) {
            message = "Dynamique négative marquée"
        } else if (d > -0.15) {
            message = "Dynamique très marquée"
            color = "orange"
        } else {
            message = "Dynamique exceptionnelle"
            color = "red"
        }
        return (
            <Box sx={{height:24,width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-around"}}>
                <Typography sx={{color: color}}>{message}</Typography>
            </Box>
        )
    }

    function generatePlusRep(perc) {

        let message = "";
        let color = "#000";
        if (perc > 0.2) {
            message = "Forte part de population"
        } else if (perc > 0.1) {
            message = "Part moyenne de la population"
        } else {
            message = "Faible part de la population"
        }
        return (
                <Typography sx={{color: color}}>{message}</Typography>

        )
    }


    if (data) {
        return (
            <Box sx={{width: '100%', display: "flex", flexDirection: "column"}}>
                <Typography variant={"h6"} sx={{
                    mb: 2,
                    color: "#000",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontSeight: 700,
                    lineSeight: "32px"
                }}>{title}</Typography>
                <Box sx={{display: "flex", flexDirection: "row", width: "100%", gap:5}}>
                    <Box sx={{width: second ? '50%' : '100%', display: "flex", flexDirection: "column"}}>
                        <Typography variant={"h8"} sx={{
                            mb: 2, display: "flex", alignItems: "center", justifyContent: "center",
                            color: "#666",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "24px"
                        }}>{t1}</Typography>
                        <Box sx={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            {data
                                .filter((d) => {
                                    return d.perc > 0.01;
                                })
                                .sort((a, b) => {
                                    return a.nb - b.nb;
                                })
                                .reverse()

                                .slice(0, n)
                                .map((d, k) => {
                                    return (
                                        <Card sx={{
                                            height: "fit-content",
                                            width: 100 / n + "%",
                                            mr: 1,
                                            borderWidth: 4,
                                            borderRadius: "10px",
                                            border: "1px solid #D30084",
                                            background: "#FFF",
                                            boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.10)"

                                        }}
                                              key={k}
                                        >
                                            <CardContent sx={{display: "flex", alignItems: "center",flexDirection: "column"}}>
                                                <Typography
                                                            sx={{
                                                                display:"flex",
                                                                justifyContent: "center",
                                                                textAlign: "center",
                                                                color: "#000",
                                                                fontSize: "20px",
                                                                fontStyle: "normal",
                                                                fontWeight: 700,
                                                                lineHeight: "32px",
                                                            }}>
                                                    {d.name}
                                                </Typography>
                                                <Typography sx={{
                                                    color: "#666",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                                    {formatNumber(d.nb)}&nbsp;{unit}
                                                </Typography>


                                                <Box sx={{width: 80, height: 80,mt:4}}>
                                                    <PieChart
                                                        style={{height: 80, width: 80, position: "absolute"}}
                                                        startAngle={-90}
                                                        data={[{
                                                            title: 'One',
                                                            value: d.perc,
                                                            color: "#f4f210"
                                                        }, {
                                                            title: 'Two',
                                                            value: 1 - d.perc,
                                                            color: "#f0f0f0"
                                                        }]}
                                                        lineWidth={15}
                                                        animate={false}
                                                    />
                                                    <Box sx={{
                                                        position: "absolute",
                                                        width: 80,
                                                        height: 80,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}>
                                                        <Typography
                                                            variant={"h6"}>{formatPercentage(d.perc)}</Typography>
                                                    </Box>
                                                </Box>
                                                <Typography sx={{
                                                    color: "#666",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                                    {generatePlusRep(d.perc)}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        display: "flex",
                                                        width: "94px",
                                                        padding: "5px 10px",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                        color: "#666",
                                                        fontSize: "16px",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "24px",
                                                        mt:2
                                                    }}>
                                                    {getTrendIcon(d.trendPerc, false)}
                                                    {formatPercentage(d.trendPerc)}
                                                </Typography>
                                                {generateAlert(d.trendPerc, d.nom, d.nombre)}
                                            </CardContent>
                                            <CardActions>
                                                {info && <AccordeonPersonna info={info} name={d.name} items={items}/>}
                                            </CardActions>
                                        </Card>)

                                })}
                        </Box>
                    </Box>

                    {second && <Box sx={{width: '50%', display: "flex", flexDirection: "column"}}>
                        <Typography variant={"h8"} sx={{
                            mb: 2, display: "flex", alignItems: "center", justifyContent: "center",
                            color: "#666",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "24px"
                        }}>{t2}</Typography>
                        {<Box sx={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            {data
                                .filter((d) => {
                                    return d.perc > 0.01;
                                })

                                .sort((a, b) => {
                                    return Math.abs(a.trendPerc) - Math.abs(b.trendPerc);
                                })
                                .reverse()
                                .slice(0, n)

                                .map((d, k) => {
                                    return (
                                        <Card sx={{
                                            height: "fit-content",
                                            width: 100 / n + "%",
                                            mr: 1,
                                            borderWidth: 4,
                                            borderRadius: "10px",
                                            border: "1px solid #D30084",
                                            background: "#FFF",
                                            boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.10)"

                                        }}
                                              key={k}
                                        >
                                            <CardContent sx={{display: "flex", alignItems: "center",flexDirection: "column"}}>
                                                <Typography
                                                    sx={{
                                                        display:"flex",
                                                        justifyContent: "center",
                                                        textAlign: "center",
                                                        color: "#000",
                                                        fontSize: "20px",
                                                        fontStyle: "normal",
                                                        fontWeight: 700,
                                                        lineHeight: "32px",
                                                    }}>
                                                    {d.name}
                                                </Typography>
                                                <Typography sx={{
                                                    color: "#666",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                                    {formatNumber(d.nb)}&nbsp;{unit}
                                                </Typography>


                                                <Box sx={{width: 80, height: 80,mt:4}}>
                                                    <PieChart
                                                        style={{height: 80, width: 80, position: "absolute"}}
                                                        startAngle={-90}
                                                        data={[{
                                                            title: 'One',
                                                            value: d.perc,
                                                            color: "#f4f210"
                                                        }, {
                                                            title: 'Two',
                                                            value: 1 - d.perc,
                                                            color: "#f0f0f0"
                                                        }]}
                                                        lineWidth={15}
                                                        animate={false}
                                                    />
                                                    <Box sx={{
                                                        position: "absolute",
                                                        width: 80,
                                                        height: 80,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}>
                                                        <Typography
                                                            variant={"h6"}>{formatPercentage(d.perc)}</Typography>
                                                    </Box>
                                                </Box>
                                                <Typography sx={{
                                                    color: "#666",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                                    {generatePlusRep(d.perc)}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        display: "flex",
                                                        width: "94px",
                                                        padding: "5px 10px",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                        color: "#666",
                                                        fontSize: "16px",
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "24px",
                                                        mt:2
                                                    }}>
                                                    {getTrendIcon(d.trendPerc, false)}
                                                    {formatPercentage(d.trendPerc)}
                                                </Typography>
                                                {generateAlert(d.trendPerc, d.nom, d.nombre)}
                                            </CardContent>
                                            <CardActions>
                                                {info && <AccordeonPersonna info={info} name={d.name} items={items}/>}
                                            </CardActions>
                                        </Card>)

                                })}

                        </Box>}
                    </Box>}
                </Box>
            </Box>
        );
    }
}
